/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { VerificationMethod } from "./VerificationMethod";
import type { VerificationStatus } from "./VerificationStatus";

export interface IdVerificationModel {
  /** The current verification status. */
  status: VerificationStatus;
  /** The verification method used. */
  method?: VerificationMethod | null;
  /** The verification vendor name (e.g., 'persona') */
  vendor?: string | null;
}
